import React, { useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import { 
    Avatar, 
    CardHeader, 
    Grid,
    Dialog,
    DialogContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        "&:hover": { opacity: 0.85 },
    },
    cardHeader: {
        padding: "4px 8px",
        cursor: "pointer",
        "& .MuiCardHeader-title": {
            fontWeight: "600",
            fontSize: "16px",
            color: theme.mode === "light" ? "#111B21" : "#E9EDEF",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "280px",
        },
        "& .MuiCardHeader-subheader": {
            fontSize: "12px",
            color: theme.mode === "light" ? "#667781" : "#8696A0",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "280px",
        },
        "& .MuiCardHeader-avatar": {
            marginRight: 10,
        },
    },
    avatar: {
        width: 42,
        height: 42,
    },
}));

const TicketInfo = ({ contact, ticket, onClick, isTyping }) => {
    const classes = useStyles();
    const [amount, setAmount] = useState("");
    const { user } = useContext(AuthContext);
    const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem

    // Função para abrir modal da imagem
    const handleImageClick = (e) => {
        e.stopPropagation(); // Prevenir que o clique no avatar execute outros handlers
        if (contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    // Função para fechar modal da imagem
    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    const renderCardReader = () => {
        const displayName = contact?.name
            ? (contact.name.length > 30 ? `${contact.name.substring(0, 30)}...` : contact.name)
            : "(sem contato)";

        return (
            <CardHeader
                onClick={onClick}
                className={classes.cardHeader}
                titleTypographyProps={{ noWrap: true }}
                subheaderTypographyProps={{ noWrap: true }}
                avatar={
                    <Avatar
                        src={contact?.urlPicture}
                        alt="contact_image"
                        className={`${classes.clickableAvatar} ${classes.avatar}`}
                        onClick={handleImageClick}
                    />
                }
                title={`${displayName} #${ticket?.id}`}
                subheader={isTyping ? "digitando..." : [
                    ticket?.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket?.user?.name}`,
                    ticket?.queue?.name && `· ${ticket.queue.name}`,
                ].filter(Boolean).join(" ")}
            />
        );
    }

    const handleChange = (event) => {
        const value = event.target.value;
        setAmount(value);
    }

    return (
        <React.Fragment>
            {renderCardReader()}

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img 
                        src={contact?.urlPicture} 
                        alt={contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;